// extracted by mini-css-extract-plugin
export default {"root":"Hpy4MOs8PE3rRRdvdPh_","label":"IgSpYM6OooAflVIY5Mhm","placeHolderShimmer":"REFyHuysRCBoj4AUVRfT"};